import {useRole} from '@/hooks';
import {PatientConsulation} from './PatientConsulation';
import {SpecialistConsultation} from './SpecialistConsultation';
import {HospitalPocConsulation} from './HospitalPocConsulation';
export const ConsultationsScreen = () => {
  const {isPatient, isSpecialist, isHospitalPoc} = useRole();
  if (isPatient) {
    return <PatientConsulation />;
  }
  if (isSpecialist) {
    return <SpecialistConsultation />;
  }
  if (isHospitalPoc) {
    return <HospitalPocConsulation />;
  }
  return 'No consultation screen';
};
